export interface IPNSJobTypes {
  id: string;
  name: string;
  type: string;
}
